import type { QuickInsertPluginOptions } from '@atlaskit/editor-plugin-quick-insert';

interface Props {
	options: Pick<
		QuickInsertPluginOptions,
		| 'enableElementBrowser'
		| 'elementBrowserHelpUrl'
		| 'emptyStateHandler'
		| 'prioritySortingFn'
		| 'onInsert'
	>;
}

export function quickInsertPluginOptions({ options }: Props): QuickInsertPluginOptions {
	return {
		enableElementBrowser: options.enableElementBrowser,
		elementBrowserHelpUrl: options.elementBrowserHelpUrl,
		disableDefaultItems: false,
		headless: false,
		emptyStateHandler: options.emptyStateHandler,
		prioritySortingFn: options.prioritySortingFn,
		onInsert: options.onInsert,
	};
}
